import React from 'react';
import { SimpleCard, Table, TableBody, TableCell, TableRow, } from '@pinwheel/origami';
import Divider from '../../../components/Divider';
import { TableLabelCell, TableValueCell } from './TableUtils';
var EmptyRow = function () { return (React.createElement(TableRow, null,
    React.createElement(TableCell, { colSpan: 2 },
        React.createElement(Divider, { style: {
                padding: '0px',
                margin: '0px',
            } })))); };
var mapGroupToTableRows = function (data) {
    return data.map(function (detail, i) {
        return detail ? (React.createElement(TableRow, { key: "DetailsTableRow-".concat(i) },
            React.createElement(TableLabelCell, null, detail.label),
            React.createElement(TableValueCell, null, detail.value))) : (React.createElement(EmptyRow, { key: "GroupedDetailsTableRow-".concat(i) }));
    });
};
var mapDataToTableRows = function (data) {
    var tableRows = [];
    for (var i = 0; i < data.length - 1; i++) {
        var currentGroup = data[i];
        tableRows.push(mapGroupToTableRows(currentGroup));
        tableRows.push(React.createElement(EmptyRow, { key: "GroupedDetailsTableRow-divider-".concat(i) }));
    }
    tableRows.push(mapGroupToTableRows(data[data.length - 1]));
    return tableRows;
};
var GroupedDetailsTable = function (_a) {
    var data = _a.data;
    return (React.createElement(SimpleCard, null,
        React.createElement(Table, null,
            React.createElement(TableBody, null, mapDataToTableRows(data)))));
};
export default GroupedDetailsTable;
